import ComboBox from '../common/ComboBox';

class DrawerZone {

    private FrontSelectorComboHTML: HTMLElement;
    private HeightLabel: HTMLElement;
    private HeightHTML: HTMLInputElement;
    private HeightUnit: HTMLSelectElement;
    private DrawerCountHTML: HTMLInputElement;

    // TODO: Type the parameters correctly
    constructor(idx: number, data: any, fronts: any[], setScript: () => void, setParameters: () => void) {

        const templates: HTMLElement = document.querySelector<HTMLElement>('[data-id="templates"]')!;
        const template: HTMLElement = templates.querySelector('[data-id="DrawerZone"]')!;
        const cloned: HTMLElement = template.cloneNode(true) as HTMLElement;
        
        // setup front selector ComboBox
        this.FrontSelectorComboHTML = cloned.querySelector<HTMLElement>('[data-id="front-selector-combo"]')!;
        const combo: ComboBox = new ComboBox();
        combo.init(this.FrontSelectorComboHTML);
        combo.selectByID(fronts[idx]);
        this.FrontSelectorComboHTML.addEventListener('changed', (e: Event) => {
            const event = e as CustomEvent<{ value: string }>;
            fronts[idx] = event.detail.value;
            console.log('combo value changed: ' + fronts[idx]);
            setScript();
            setParameters();
        });

        this.HeightLabel = cloned.querySelector<HTMLElement>('[data-id="height-label"]')!;
        this.HeightHTML = cloned.querySelector<HTMLInputElement>('[data-id="height"]')!;
        this.HeightUnit = cloned.querySelector<HTMLSelectElement>('[data-id="height-unit"]')!;
        if(data.Height != null) {

            const match: RegExpMatchArray | null = data.Height.match(/^(\d+)(auto|mm|\*|\%)$/);

            if (match != null) {
                this.HeightHTML.value = match[1];

                this.HeightHTML.addEventListener('change', () => {
                    data.Height = this.HeightHTML.value + this.HeightUnit.value;
                    console.log("height changed: " + data.Height);
                    setScript();
                    setParameters();
                });

                // HeightUnit is a <select> element
                this.HeightUnit.value = match[2];
                this.updateUI(this.HeightUnit.value);

                this.HeightUnit.addEventListener("change", () => {
                    data.Height = this.HeightHTML.value + this.HeightUnit.value;
                    this.updateUI(this.HeightUnit.value);
                    console.log("height unit changed: " + data.Height);
                    setScript();
                    setParameters();    
                });
            } else {
                console.error("DrawerZone: Invalid height data: " + data.Height);
            }

        } else {
            this.HeightLabel.classList.add("hidden");
            cloned.querySelector<HTMLElement>('[data-id="height-group"]')!.classList.add("hidden");
        }

        this.DrawerCountHTML = cloned.querySelector<HTMLInputElement>('[data-id="drawer-count"]')!;
        this.DrawerCountHTML.value = data.DrawerCount;
        this.DrawerCountHTML.addEventListener('change', (event: Event) => {
            data.DrawerCount = (event.target! as HTMLInputElement).value;
            console.log("drawerCount changed: " + data.DrawerCount);
            setScript();
            setParameters();
        });

        const target: HTMLElement = document.querySelector<HTMLElement>('[data-id="zones"] [data-id="content"]')!;
        //target.appendChild(cloned);
        target.insertBefore(cloned, target.firstChild); // reverse visual order
    }

    private updateUI(unit: string): void {
        if(unit === "auto") {
            this.HeightHTML.classList.add("hidden");
        } else {
            this.HeightHTML.classList.remove("hidden");
        }
    }
}

export default DrawerZone;
